import React from 'react';
import { NumericTextBox } from "@progress/kendo-react-inputs";

export default class MaxOutOfPocketPanel extends React.Component {

    handleMaxOutOfPocketChange = (e) => {
        this.props.onMaxOutOfPocketChange(e.value);
    }

    handleMaxOutOfPocketPaidInChange = (e) => {
        this.props.onMaxOutOfPocketPaidInChange(e.value);
    }

    handleMaxOutOfPocketRemainingChange = (e) => {
        this.props.onMaxOutOfPocketRemainingChange(e.value);
    }

    selectContentsOnFocus = (e) => {
        e.target.element.select();
    }

    render() {
        return (
            <div id={this.props.id} className="card shadow">
                <div className="card-body">
                    <h5 className="card-title">Max Out Of Pocket</h5>
                    <div className="row">
                        <div className="col-sm-4 col-lg-6">
                            <label className="form-label">Amount</label>
                        </div>
                        <div className="col-sm-4 col-lg-6">
                            <NumericTextBox
                                spinners={false}
                                min={0}
                                format="$0.00"
                                value={this.props.maxOutOfPocket}
                                onChange={this.handleMaxOutOfPocketChange}
                                readOnly={!this.props.enabled}
                                onFocus={this.selectContentsOnFocus}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 col-lg-6">
                            <label className="form-label">Total Paid</label>
                        </div>
                        <div className="col-sm-4 col-lg-6">
                            <NumericTextBox
                                spinners={false}
                                format="$0.00"
                                value={this.props.maxOutOfPocketPaidIn}
                                onChange={this.handleMaxOutOfPocketPaidInChange}
                                readOnly={!this.props.enabled}
                                onFocus={this.selectContentsOnFocus}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 col-lg-6">
                            <label className="form-label">Remaining</label>
                        </div>
                        <div className="col-sm-4 col-lg-6">
                            <NumericTextBox
                                spinners={false}
                                format="$0.00"
                                value={this.props.maxOutOfPocketRemaining}
                                onChange={this.handleMaxOutOfPocketRemainingChange}
                                readOnly={!this.props.enabled}
                                onFocus={this.selectContentsOnFocus}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}